/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LicenceStatus
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type licenceStatusRetrieveResponse200 = {
  data: LicenceStatus
  status: 200
}
    
export type licenceStatusRetrieveResponseSuccess = (licenceStatusRetrieveResponse200) & {
  headers: Headers;
};
;

export type licenceStatusRetrieveResponse = (licenceStatusRetrieveResponseSuccess)

export const getLicenceStatusRetrieveUrl = () => {


  

  return `/api/v1/licence/status/`
}

export const licenceStatusRetrieve = async ( options?: RequestInit): Promise<licenceStatusRetrieveResponse> => {
  
  return apiFetch<licenceStatusRetrieveResponse>(getLicenceStatusRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getLicenceStatusRetrieveQueryKey = () => {
    return [
    `/api/v1/licence/status/`
    ] as const;
    }

    
export const getLicenceStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLicenceStatusRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof licenceStatusRetrieve>>> = ({ signal }) => licenceStatusRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LicenceStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof licenceStatusRetrieve>>>
export type LicenceStatusRetrieveQueryError = unknown


export function useLicenceStatusRetrieve<TData = Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof licenceStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof licenceStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLicenceStatusRetrieve<TData = Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof licenceStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof licenceStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLicenceStatusRetrieve<TData = Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLicenceStatusRetrieve<TData = Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof licenceStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLicenceStatusRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




